import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_SHIPPING_METHOD_TRANSLATION_REQUEST = "API_SHIPPING_METHOD_TRANSLATION_REQUEST";
export const API_SHIPPING_METHOD_TRANSLATION_SUCCESS = "API_SHIPPING_METHOD_TRANSLATION_SUCCESS";
export const API_SHIPPING_METHOD_TRANSLATION_FAILURE = "API_SHIPPING_METHOD_TRANSLATION_FAILURE";

export const api_shipping_method_translation_request = (options) => {
	return {
		type: API_SHIPPING_METHOD_TRANSLATION_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_shipping_method_translation_success = (data) => {
	return {
		type: API_SHIPPING_METHOD_TRANSLATION_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_shipping_method_translation_failure = (error) => {
	return {
		type: API_SHIPPING_METHOD_TRANSLATION_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	ShippingMethod.apiShippingMethodTranslation
	return Translations for ShippingMethods
			:return: {Method{DE:"UPS"}}
*/
export const apiShippingMethodTranslation = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_shipping_method_translation_request(options));
			const url=getAPIUrl([
				{"url": "/api/shipping_method/translation", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_shipping_method_translation_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_shipping_method_translation_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
